import { Divider } from "antd";
import { useMemo } from "react";
import CommonIcons from "../../../assets/icons";

const AssetsComp = (props: any) =>
{


      const arrGroup = useMemo(() =>
      {
            if (!props?.data) return [];

            // Keep the asset key (band0, tci, thumbnail, ...) so it can be the header.
            return Object.keys(props.data).map((key) => ({
                  __assetKey: key,
                  ...props.data[key],
            }));
      }, [props?.data]);

      const renderArray = (arr: any[]) =>
      {
            return (
                  <div className="flex justify-end text-[11px] flex-wrap gap-x-1">
                        {arr.map((item, index) =>
                        {
                              if (item === null || typeof item !== "object")
                              {
                                    return (
                                          <span key={index} className="text-red-400">
                                                {item}
                                                {index !== arr.length - 1 ? "," : ""}
                                          </span>
                                    );
                              }

                              return (
                                    <div key={index} className="w-full pl-3">
                                          {Object.keys(item).map((k) =>
                                                renderObject(k, item[k], false)
                                          )}
                                    </div>
                              );
                        })}
                  </div>
            );
      };

      const renderObject = (
            key: string,
            value: any,
            isColumn: boolean = true
      ) =>
      {
            return (
                  <div
                        key={key}
                        className={`flex w-full text-[11px] gap-1 ${isColumn ? "flex-col" : "flex-row"
                              }`}
                  >
                        <span>{key}:</span>

                        {(value === null || typeof value !== "object") && (
                              <span
                                    className="text-right w-full text-des truncate"
                                    title={value}
                              >
                                    {value}
                              </span>
                        )}

                        {value !== null && typeof value === "object" && !Array.isArray(value) && (
                              <div className="flex flex-col pl-3 gap-1">
                                    {Object.keys(value).map((k) =>
                                          renderObject(k, value[k], false)
                                    )}
                              </div>
                        )}

                        {Array.isArray(value) && renderArray(value)}
                  </div>
            );
      };

      return (
            <div className="mt-4 space-y-2">
                  {arrGroup.map((item: any, index: number) =>
                  {
                        const title = item?.__assetKey ?? "";

                        return (
                              <details
                                    key={index}
                                    className="rounded-md px-3 py-2 group "
                                    style={{

                                          background: "var(--neutral-800)",
                                    }}
                              >
                                    <summary
                                          className="flex group-open:pb-4  items-center justify-between text-sm capitalize list-none cursor-pointer"

                                          title={item?.__assetKey}
                                    >
                                          <span className="truncate">{title}</span>

                                          <span className="transition-transform group-open:rotate-180">
                                                <CommonIcons.ChevronUpIcon />
                                          </span>
                                    </summary>


                                    <div className="py-2 pt-4  flex flex-col gap-y-2 text-[11px] border-t border-solid border-[var(--divider-2)]">
                                          {Object.keys(item).map((key) =>
                                          {
                                                if (key === "__assetKey") return null;

                                                if (item[key] === null || typeof item[key] !== "object")
                                                {
                                                      return (
                                                            <div
                                                                  key={key}
                                                                  className="flex flex-row w-full"
                                                            >
                                                                  <span>{key}:</span>

                                                                  <span
                                                                        className="text-right w-full truncate text-gray-300"
                                                                        title={item[key]}
                                                                  >
                                                                        {item[key]}
                                                                  </span>
                                                            </div>
                                                      );
                                                }

                                                return renderObject(key, item[key]);
                                          })}
                                    </div>
                              </details>
                        );
                  })}
            </div>
      );
};

export default AssetsComp;